import React, { Component, Fragment } from 'react';
import FlipMove from 'react-flip-move';
import { DIRECTION_FLIGHT } from 'components/components/booking/utils/FlightConstants';
import withRouter from 'components/components/common/withRouter';
import AddressHelper from '../utils/AddressHelper';
import TimetableHelper from '../utils/TimetableHelper';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';
import classNames from 'classnames';

class SummaryBooking extends React.Component {

  state = {
    tooltipShow: false,
  }

  showSummary = () => {
    var isReturnChosen = true;
    if (this.props.returnFlight) {
      if (this.props.differentReturnAddress) {
        isReturnChosen = this.props.returnAddress.selectedObject;
      }
    }
    return this.props.departureAddress.selectedObject && isReturnChosen;
  }

  getDepartureText = () => {
    var timetableHelper = new TimetableHelper(this.props.departureFlight, this.props.departureAddress);
    var timetableInfo = timetableHelper.getTimetableInfo();
    return this.fromT() + ' ' + this.getText(this.props.departureFlight, this.props.departureAddress, timetableInfo);
  }

  getReturnText = () => {
    if (this.props.differentReturnAddress) {
      var timetableHelper = new TimetableHelper(this.props.returnFlight, this.props.returnAddress);
      var timetableInfo = timetableHelper.getTimetableInfo();
      return this.fromT() + ' ' + this.getText(this.props.returnFlight, this.props.returnAddress, timetableInfo);
    } else {
      var timetableHelper = new TimetableHelper(this.props.returnFlight, this.props.departureAddress);
      var timetableInfo = timetableHelper.getTimetableInfo();
      return this.fromT() + ' ' + this.getText(this.props.returnFlight, this.props.departureAddress, timetableInfo);
    }
  }

  getText(flightObject, addressObject, timetableInfo) {
    var busStopTimeText = '';
    var airportTimeText = '';
    if (timetableInfo) {
      busStopTimeText = timetableInfo.busStopTime;
      airportTimeText = timetableInfo.airportTime;
    }
    //from oslo to airport
    if (flightObject.direction === DIRECTION_FLIGHT) {
      return `${addressObject.selectedObject.label} ${busStopTimeText} ${this.toT()} ${flightObject.airport.name} ${airportTimeText}`;
    } else {
      //from airport to address
      return `${flightObject.airport.name} ${airportTimeText} ${this.toT()} ${addressObject.selectedObject.label} ${busStopTimeText}`;
    }
  }

  getReturnContent = () => {
    if (this.props.returnFlight) {
      return (
        <tr>
          <td className="list-order__label">{this.getReturnText()}</td>
          <td className="list-order__price">
            {this.getReturnPrice()} <span className="currency">
              <T>content.common.currency</T>
            </span>
          </td>
        </tr>
      );
    } else {
      return null;
    }
  }

  goNext = (e) => {
    e.preventDefault();
    if (this.props.isLogged) {
      TransHelper.redirect(this.props, 'routes.url.summary');
    } else {
      TransHelper.redirect(this.props, 'routes.url.userData');
    }
  }

  isDisableButton() {
    var addressHelper = new AddressHelper(this.props);
    return !addressHelper.isValid();
  }

  getDeparturePrice() {
    return this.returnPrice(this.props.departurePrice);
  }

  getTotalPrice() {
    return this.returnPrice(this.props.departurePrice + this.props.returnPrice);
  }

  getReturnPrice() {
    return this.returnPrice(this.props.returnPrice);
  }

  returnPrice(price) {
    if (this.props.loadingDataOnMap) {
      return <i className="loader loader--small"></i>;
    } else {
      var addressHelper = new AddressHelper(this.props);
      if (addressHelper.isValid()) {
        return price;
      } else {
        return '-';
      }
    }
  }

  showTooltip = (e) => {
    e.preventDefault();
    this.setState({ tooltipShow: true })
  }

  hideTooltip = (e) => {
    e.preventDefault();
    this.setState({ tooltipShow: false })
  }

  t = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  fromT = () => {
    return this.t('content.bookingStep3.summary.from');
  }

  toT = () => {
    return this.t('content.bookingStep3.summary.to');
  }

  render() {
    const { tooltipShow } = this.state;

    return (
      <div style={{ position: 'relative', height: '100%', width: '100%' }}>
        <FlipMove
          duration={150}
          easing="ease-out"
          enterAnimation="fade"
          leaveAnimation="fade"
          typeName={null}>
          {this.showSummary() &&
            <div className="map__summary-wrap">

              <div className="summary-tooltip">
                <div className="summary-tooltip__wrap">
                  <button onClick={this.showTooltip}>
                    <T>content.bookingStep3.summary.tooltip.button</T>
                    <i className="fa-bulb--tooltip"></i>
                  </button>

                  <div className={classNames(
                    'summary-tooltip__desc', {
                    'summary-tooltip__desc--show': tooltipShow,
                  })}
                    onClick={this.hideTooltip}
                  >
                    <p>
                      <T>content.bookingStep3.summary.tooltip.departures</T>
                    </p>
                    <p>
                      <T>content.bookingStep3.summary.tooltip.arrivals</T>
                    </p>
                    <i className="fa-bulb--tooltip"></i>
                  </div>
                </div>

              </div>

              <table className="list-order">
                <tbody>
                  <tr>
                    <td className="list-order__label">{this.getDepartureText()}</td>
                    <td className="list-order__price">
                      {this.getDeparturePrice()} <span className="currency">
                        <T>content.common.currency</T>
                      </span>
                    </td>
                  </tr>
                  {this.getReturnContent()}
                  <tr>
                    <td className="list-order__label list-order__label--big">
                      <T>content.bookingStep3.summary.totalPrice</T>
                    </td>
                    <td className="list-order__price list-order__price--big">
                      {this.getTotalPrice()} <span className="currency">
                        <T>content.common.currency</T>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                className="button button--outline button--expand"
                onClick={this.goNext}
                disabled={this.isDisableButton()}
              >
                <T>content.common.next</T>
              </button>
            </div>
          }
        </FlipMove>
      </div>
    );
  }
}

export default withRouter(SummaryBooking);
